import { FC } from 'react';
import NavCommon from '../../Teaser/NavCommon';
import { useLang } from '@/i18n';

interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.end');

    const navList: { title: string; href: string }[] = [
        {
            title: t('nav.title1'),
            href: 'teaser-CelebratingUs',
        },
        {
            title: t('nav.title2'),
            href: 'teaser-EcoBenefits',
        },
        {
            title: t('nav.title3'),
            href: 'ReferralNextEnd',
        },
    ];

    return (
        <>
            <NavCommon list={navList} />
        </>
    );
};

export default Banner;
